import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    issue: 'Cantidades ajustadas automáticamente',
    without: 'Para 4 personas',
    with: 'Para 6+ personas. Listo.'
  }, {
    issue: 'Recetas en formato "Olla Grande"',
    without: 'Recetas estándar',
    with: 'Técnicas para cocinar en volumen.'
  }, {
    issue: 'Presupuesto y lista de compras',
    without: 'Lista base',
    with: 'Lista extendida con compras mayoristas.'
  }, {
    issue: 'Planificación de viandas escolares',
    without: 'Viandas básicas',
    with: 'Sistema de viandas múltiples.'
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-37">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-38">
        <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-10" data-id="element-39">
          ¿Qué agrega el Kit Familia Grande?
        </h3>

        <div className="overflow-x-auto rounded-2xl border border-navy-700 bg-navy-800/30" data-id="element-40">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-41">
            <thead data-id="element-42">
              <tr data-id="element-43">
                <th className="p-4 md:p-6 border-b border-navy-700 w-1/3" data-id="element-44"></th>
                <th className="p-4 md:p-6 border-b border-navy-700 bg-navy-900/50 text-center text-gray-400 font-medium w-1/3" data-id="element-45">
                  MegaPack Base
                </th>
                <th className="p-4 md:p-6 border-b border-navy-700 bg-gold-500/10 text-center text-gold-400 font-bold w-1/3" data-id="element-46">
                  Kit Familia Grande
                </th>
              </tr>
            </thead>
            <tbody data-id="element-47">
              {rows.map((row, index) => <tr key={index} className="border-b border-navy-700/50 last:border-0 hover:bg-navy-800/50 transition-colors" data-id="element-48">
                  <td className="p-4 md:p-6 text-blue-50 font-medium" data-id="element-49">
                    {row.issue}
                  </td>
                  <td className="p-4 md:p-6 bg-navy-900/30 text-center text-gray-500" data-id="element-50">
                    <span className="text-sm" data-id="element-51">{row.without}</span>
                  </td>
                  <td className="p-4 md:p-6 bg-gold-500/5 text-center text-white" data-id="element-52">
                    <Check className="w-5 h-5 mx-auto mb-1 text-gold-400" data-id="element-53" />
                    <span className="text-sm" data-id="element-54">{row.with}</span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.div>
    </section>;
}